<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created: function () {
    this.$axios.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch(logout)
        }
        throw err;
      });
    });
  },
  data() {
    return {
      previousRoutePath: null,
    }
  },
  watch: {
    $route (to, from) {
      window.localStorage.setItem('secondPreviousRoutePath', this.previousRoutePath);
      window.localStorage.setItem('previousRoutePath', from.path);
      this.previousRoutePath = from.path;
    }
  } 
}
</script>

<style>
  #app {
    display: contents;
  }
</style>
